import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

import InputContainer from '~COMPONENTS/formInputs/containers/InputContainer';
import TextInput from '~COMPONENTS/formInputs/TextInput';

const ReturnDetailsSearch = ({ searchTerm, onChange }) => (
  <div className='returnDetails__search prl3-xl pt5-sm'>
    <InputContainer
      label={new TranslatedCopy({ id: 'orderreturns.search' }).toString()}
      extraClassName='returnDetails__search_inputContainer'
      isSearch
    >
      <TextInput
        type='text'
        autoComplete='off'
        name='returnDetails__search_textInput'
        value={searchTerm}
        onChange={onChange}
      />
    </InputContainer>
  </div>
);

ReturnDetailsSearch.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ReturnDetailsSearch;
